/*const googleMapConfig = Object.freeze({
    isGoogleMapActive: false,
    apiKey: MAP_KEY,
    attribution: '&copy; Titan',
});*/

const openStreetMapConfig = Object.freeze({
    isGoogleMapActive: false,
    attribution: '&copy; Titan',
    map_view1: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    map_view2: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    map_view3:
        'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png',
    map_view4: `https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_API_KEY}`,
});

export default openStreetMapConfig;
